import {AnimatePresence, motion} from "motion/react";
import {OverlayContent} from "~/components/header/collapsed-header/subnavigation/common";
import * as React from "react";

export const SlideMenu = ({menuOpen, close, onOpenLocaleDialog}: { menuOpen: boolean, close: () => void, onOpenLocaleDialog: () => void}) => {
    return (
        <AnimatePresence>
            {menuOpen && (
                <motion.div
                    key="slide-menu"
                    initial={{y: "-100%"}}
                    animate={{y: "0%", transition: {duration: 0.38, ease: [0.16, 1, 0.3, 1]}}}
                    exit={{y: "-100%", transition: {duration: 0.26, ease: [0.4, 0, 1, 1]}}}
                    className="bg-nav-surface text-text-heading fixed inset-0 z-[200] flex flex-col"
                >
                    <OverlayContent close={close} onOpenLocaleDialog={onOpenLocaleDialog}/>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
